import { render } from "./PrescriptionDetails.vue?vue&type=template&id=0230d902"
import script from "./PrescriptionDetails.vue?vue&type=script&lang=js"
export * from "./PrescriptionDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__